module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("ioOBM"))).then(() => parcelRequire('3xV26'));